import { Cct, Client, LppPlan } from "../__generated__/graphql";

type LppCanChangeConfiguration = {
    [key: string]: {
        [workerGroup: string]: boolean;
    };
};

type LppConfiguration = {
    cctGroups: {
        [key: string]: {
            [workerGroup: string]: LppPlan;
        };
    };
};

export const canChangeLppConfiguration = (
    client: Client,
    cct: Cct,
    availablePlans: LppPlan[],
    workerGroup: string,
): boolean => {
    const canChangeLppConfig = client.canChangeLppConfiguration as
        | LppCanChangeConfiguration
        | null
        | undefined;

    if (availablePlans.length === 0) {
        // if no LPP available we can not change
        return false;
    }
    if (availablePlans.length === 1) {
        return false;
    }

    // availablePlans.length > 1
    // if multiple plan we can always choose exept if we already choose a plan for the
    // current CCT and worker group
    if (!canChangeLppConfig) {
        return true;
    }
    if (cct.cctContractId.startsWith("lift-no-cct")) {
        return canChangeLppConfig["none"]?.[workerGroup] !== false;
    }
    return canChangeLppConfig[cct.cctContractId]?.[workerGroup] !== false;
};

export const getLppPlanFromConfiguration = (
    client: Client,
    cct: Cct,
    workerGroup: string,
    availablePlans: LppPlan[],
): LppPlan | undefined | null => {
    const config = client.lppConfiguration as LppConfiguration | null | undefined;
    if (config) {
        let workerConfig: LppPlan | null | undefined;

        if (cct.cctContractId.startsWith("lift-no-cct")) {
            workerConfig = config.cctGroups["none"]?.[workerGroup];
        } else {
            workerConfig = config.cctGroups[cct.cctContractId]?.[workerGroup];
        }
        if (workerConfig) {
            return workerConfig;
        }
    }

    // if only one plan use it as default
    if (availablePlans.length === 1) {
        return availablePlans[0];
    }

    // if no plan exists we choose no plan
    if (availablePlans.length === 0) {
        return null;
    }

    // multiple plans and no configured default: the employer must explicitly select one
    return undefined;
};
